import match from "autosuggest-highlight/match";
import parse from "autosuggest-highlight/parse";
import React from "react";

const HandleRenderOption = (props, option) => {
  const matches = match(props, option.inputValue?.trim(), {
    insideWords: true
  });
  const parts = parse(props, matches);

  const highlightStyle = {
    fontWeight: 700
  };

  return (
    <li>
      {parts.map((part, index) => (
        <span key={index} style={part.highlight ? highlightStyle : {}}>
          {part.text}
        </span>
      ))}
    </li>
  );
};

export default HandleRenderOption;
